(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tt-print-options"] && !Shopify.designMode) return;
  try {
    class TtPrintOptions extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.nameToggle = this.querySelector('[data-tt-name-toggle]');
      this.nameFields = this.querySelector('[data-tt-name-fields]');
      this.nameInput = this.querySelector('[data-tt-name-input]');
      this.placements = [...this.querySelectorAll('[data-tt-placement]')];
      this.nameToggle?.addEventListener('change', () => this.updateNameFields(true));
      document.getElementById(this.dataset.formId)?.addEventListener('reset', () => {
        requestAnimationFrame(() => this.updateNameFields(false));
      });
      this.updateNameFields(false);
    }

    updateNameFields(focusInput) {
      if (!this.nameToggle || !this.nameFields || !this.nameInput) return;
      const enabled = this.nameToggle.checked;
      this.nameFields.hidden = !enabled;
      this.nameInput.disabled = !enabled;
      this.nameInput.required = enabled;
      this.placements.forEach((input) => {
        input.disabled = !enabled;
      });
      if (!enabled) this.nameInput.value = '';
      if (enabled && focusInput) this.nameInput.focus();
    }
  }

  if (!customElements.get('tt-print-options')) {
    customElements.define('tt-print-options', TtPrintOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
